<template>
  <div>
    <v-row>
      <v-col>
        <v-alert v-if="show_comment" type="error" color="red lighten-2">{{ comment }}</v-alert>
        <v-alert v-if="show_success" type="success" color="green lighten-2">Документы прошли проверку</v-alert>
        <v-alert v-if="show_wait" icon="mdi-timer-sand-empty" color="yellow lighten-4"
          >Документы отправлены на проверку</v-alert>
      </v-col>
    </v-row>
    <v-row class="mb-5">
      <v-col v-for="attachment in attachmentsWithOneFile" :key="attachment.name">
        <AttachmentUpload
          @attachment-file-add="addFile"
          @attachment-file-remove="onFileRemove"
          :value="getAttachmentFileOrNothing(attachment.files, 0)"
          :label="attachment.title"
          :name="attachment.name"
          :context-id="oid"
          :context-name="attachmentMetadata.contextName"
          :group-name="attachmentMetadata.groupName"
        />
      </v-col>
    </v-row>
    <v-row v-for="attachment in attachmentsWithMultipleFiles" :key="attachment.name">
      <v-col>
        <AttachmentUpload
          multi
          @attachment-file-add="addFile"
          @attachment-file-remove="onFileRemove"
          :value="attachment.files"
          :label="attachment.title"
          :name="attachment.name"
          :context-id="oid"
          :context-name="attachmentMetadata.contextName"
          :group-name="attachmentMetadata.groupName"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import AttachmentUpload from "@/components/common/AttachmentUpload";

export default {
  name: "AppFLTab",

  data: () => ({
    attachmentMetadata: {
      contextName: 'app:person',
      groupName: "fl_resident_passport"
    }
  }),
  props: {
    selectedPerson: {
      type: Number,
    },
  },
  components: { AttachmentUpload },
  computed: {
    ...mapState("app", ["appId"]),
    ...mapGetters("app", ["fl"]),

    // доки для выбранного лица:
    attachmentsList() {
      const attachments = this.fl[this.selectedPerson]?.attachments;
      if (!attachments) {
        return [];
      }

      return attachments.map(item => {
        const maxFiles = item.properties?.max_files;
        const minFiles = item.properties?.min_files ?? 0;
        return {
          ...item,
          isMultiple: (!maxFiles || maxFiles > 1 || minFiles > 1)
        }
      });
    },

    attachmentsWithOneFile() {
      return this.attachmentsList.filter(attachment => !attachment.isMultiple);
    },

    attachmentsWithMultipleFiles() {
      return this.attachmentsList.filter(attachment => attachment.isMultiple);
    },

    // для привязки файлов к фл по его id
    oid() {
      return this.fl[this.selectedPerson]?.id;
    },

    comment() {
      return this.fl[this.selectedPerson]?.decline_reason;
    },

    show_comment() {
      return this.fl[this.selectedPerson]?.is_approved === false;
    },
    show_success() {
      return this.fl[this.selectedPerson]?.is_approved === true;
    },
    show_wait() {
      return this.sended && this.fl[this.selectedPerson]?.is_approved === null;
    },
    sended() {
      return this.fl[this.selectedPerson]?.sended;
    },
  },
  methods: {
    ...mapMutations("app", ["setFlDocsFor"]),

    getAttachmentFileOrNothing: (list, idx) => list?.[idx],
    getAttachmentPropertyOrNothing: (attachment, property) => attachment.properties?.[property],

    updateCurrentPersonAttachmentsList(name, files) {
      const attachmentFiles = this.attachmentsList.find(item => item.name === name);
      if (attachmentFiles) {
        attachmentFiles.files = files;
        this.setFlDocsFor({ index: this.selectedPerson, docs: this.attachmentsList });
      }
    },

    addFile({ name, updatedList }) {
      this.updateCurrentPersonAttachmentsList(name, updatedList);
    },

    onFileRemove({ name, updatedList }) {
      this.updateCurrentPersonAttachmentsList(name, updatedList);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn__send {
  position: fixed;
  right: 15px;
}
</style>
